/*
 * urikire お気に入り（ウィッシュリスト）
 * 保存先はブラウザの localStorage のみ。ログイン不要・外部通信なし。
 * 何かあっても店頭表示を壊さないよう、全処理を try/catch で保護している。
 */
(function () {
  'use strict';

  var KEY = 'urikire_wishlist_v1';
  var MAX = 50;

  function read() {
    try {
      var raw = window.localStorage.getItem(KEY);
      if (!raw) return [];
      var arr = JSON.parse(raw);
      return Array.isArray(arr) ? arr.filter(function (i) { return i && i.h; }) : [];
    } catch (e) {
      return [];
    }
  }

  function write(list) {
    try {
      window.localStorage.setItem(KEY, JSON.stringify(list.slice(0, MAX)));
    } catch (e) {
      /* 保存できなくても表示は壊さない */
    }
  }

  function has(handle) {
    var list = read();
    for (var i = 0; i < list.length; i++) {
      if (list[i].h === handle) return true;
    }
    return false;
  }

  function add(item) {
    var list = read();
    if (has(item.h)) return;
    list.unshift(item);
    write(list);
  }

  function remove(handle) {
    write(read().filter(function (i) { return i.h !== handle; }));
  }

  function closestEl(node, selector) {
    try {
      var el = node;
      while (el && el.nodeType !== 1) el = el.parentNode;
      if (!el || !el.closest) return null;
      return el.closest(selector);
    } catch (e) {
      return null;
    }
  }

  function syncButtons() {
    try {
      var n = read().length;
      var btns = document.querySelectorAll('.wishlist-toggle');
      for (var i = 0; i < btns.length; i++) {
        var b = btns[i];
        var on = has(b.getAttribute('data-handle'));
        var label = b.getAttribute(on ? 'data-label-on' : 'data-label-off') || '';
        if (on) { b.classList.add('is-active'); } else { b.classList.remove('is-active'); }
        b.setAttribute('aria-pressed', on ? 'true' : 'false');
        b.setAttribute('aria-label', label);
        var t = b.querySelector('.wishlist-toggle__label');
        if (t) t.textContent = label;
      }
      var counters = document.querySelectorAll('[data-wishlist-count]');
      for (var j = 0; j < counters.length; j++) {
        counters[j].textContent = String(n);
        counters[j].hidden = n === 0;
      }
    } catch (e) {}
  }

  function renderPage() {
    try {
      var root = document.querySelector('[data-wishlist-list]');
      if (!root) return;
      var empty = document.querySelector('[data-wishlist-empty]');
      var items = read();
      while (root.firstChild) root.removeChild(root.firstChild);

      if (!items.length) {
        if (empty) empty.hidden = false;
        return;
      }
      if (empty) empty.hidden = true;

      for (var i = 0; i < items.length; i++) {
        var it = items[i];
        var li = document.createElement('li');
        li.className = 'wishlist-grid__item';

        var a = document.createElement('a');
        a.className = 'wishlist-card';
        a.href = it.u || ('/products/' + it.h);

        var media = document.createElement('div');
        media.className = 'wishlist-card__media';
        if (it.i) {
          var img = document.createElement('img');
          img.src = it.i;
          img.alt = '';
          img.loading = 'lazy';
          media.appendChild(img);
        }

        var info = document.createElement('div');
        info.className = 'wishlist-card__info';
        var title = document.createElement('span');
        title.className = 'wishlist-card__title';
        title.textContent = it.t || '';
        var price = document.createElement('span');
        price.className = 'wishlist-card__price';
        price.textContent = it.p || '';
        info.appendChild(title);
        info.appendChild(price);

        a.appendChild(media);
        a.appendChild(info);

        var del = document.createElement('button');
        del.type = 'button';
        del.className = 'wishlist-card__remove';
        del.setAttribute('data-wishlist-remove', it.h);
        del.setAttribute('aria-label', 'お気に入りから削除');
        del.textContent = '×';

        li.appendChild(a);
        li.appendChild(del);
        root.appendChild(li);
      }
    } catch (e) {}
  }

  document.addEventListener('click', function (e) {
    var btn = closestEl(e.target, '.wishlist-toggle');
    if (btn) {
      e.preventDefault();
      e.stopPropagation();
      try {
        var h = btn.getAttribute('data-handle');
        if (!h) return;
        if (has(h)) {
          remove(h);
        } else {
          add({
            h: h,
            t: btn.getAttribute('data-title') || '',
            u: btn.getAttribute('data-url') || ('/products/' + h),
            i: btn.getAttribute('data-image') || '',
            p: btn.getAttribute('data-price') || ''
          });
        }
        syncButtons();
        renderPage();
      } catch (err) {}
      return;
    }

    var rm = closestEl(e.target, '[data-wishlist-remove]');
    if (rm) {
      e.preventDefault();
      try {
        remove(rm.getAttribute('data-wishlist-remove'));
        renderPage();
        syncButtons();
      } catch (err) {}
    }
  }, true);

  function init() {
    syncButtons();
    renderPage();
    try {
      var grid = document.getElementById('ProductGridContainer');
      if (grid && window.MutationObserver) {
        var timer = null;
        new MutationObserver(function () {
          if (timer) window.clearTimeout(timer);
          timer = window.setTimeout(syncButtons, 80);
        }).observe(grid, { childList: true, subtree: true });
      }
    } catch (e) {}
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
